<template>
  <div class="text-left">
    <div class="mb-8 flex justify-between">
      <div v-if="firstTime">
        <h4 class="mb-2 text-dark-blue">Select the regions you run in.</h4>
        <p class="text-body-color">Click to select</p>
      </div>
      <div v-else>
        <h4 class="my-3 text-dark-blue">
          Please confirm the regions you run in.
        </h4>
        <div class="flex">
          <div class="mr-6">
            <label class="text-2xs font-bold text-gray-over-dark">
              US REGIONS
            </label>
            <p
              v-for="region in regions"
              :key="region"
              class="text-dark-gray"
            >
              {{ region }}
            </p>
          </div>
          <div class="mr-6">
            <label class="text-2xs font-bold text-gray-over-dark">
              RUNS IN CANADA
            </label>
            <p class="text-dark-gray">
              {{ canada ? 'Yes' : 'No' }}
            </p>
          </div>
          <div>
            <label class="text-2xs font-bold text-gray-over-dark">
              RUNS IN MEXICO
            </label>
            <p class="text-dark-gray">
              {{ mexico ? 'Yes' : 'No' }}
            </p>
          </div>
        </div>
      </div>
      <div class="flex flex-col rounded-md border border-light-gray p-2">
        <div class="flex">
          <p class="mr-2 text-2xs font-bold capitalize text-dark-blue">
            INSPECTIONS
          </p>
          <p class="text-2xs font-bold text-body-color">LAST 24 MOS</p>
        </div>
        <div class="my-2 flex items-center">
          <img
            src="@/assets/lanes/key_obs_desktop.svg"
            alt="observed key"
          />
          <p class="mx-2 text-body-color">Observed Inspections</p>
        </div>
        <div class="mb-2 flex items-center">
          <img
            src="@/assets/lanes/key_preferred.svg"
            alt="observed key"
            style="width: 24px; height: 24px"
          />
          <p class="mx-2 text-body-color">Preferred States</p>
        </div>
        <div class="flex items-center">
          <img
            src="@/assets/lanes/key_pref_observed.svg"
            alt="observed key"
            style="width: 24px; height: 24px"
          />
          <p class="mx-2 text-body-color">Preferred + Observed</p>
        </div>
      </div>
    </div>
    <us-regional-map
      id="us_regional_map_by_state"
      :first-time="false"
    />
    <div
      v-if="firstTime"
      class="mt-8 flex gap-8"
    >
      <div class="flex w-1/2 flex-col text-left">
        <label class="text-2xs font-bold text-gray-over-dark">
          I RUN IN CANADA (REQUIRED)
        </label>
        <div class="mt-2">
          <yes-no
            :field="`lanes.countries.canada`"
            :yes-checked="typeof canada === 'boolean' && canada"
            :no-checked="typeof canada === 'boolean' && !canada"
            :handle-click="handleClickCanada"
            value="'canada'"
            :small-gap="true"
          />
        </div>
      </div>
      <div class="mb-2 flex w-1/2 flex-col text-left">
        <label class="text-2xs font-bold text-gray-over-dark">
          I RUN IN MEXICO (REQUIRED)
        </label>
        <div class="mt-2">
          <yes-no
            :field="`lanes.countries.mexico`"
            :yes-checked="typeof mexico === 'boolean' && mexico"
            :no-checked="typeof mexico === 'boolean' && !mexico"
            :handle-click="handleClickMexico"
            value="'mexico'"
            :small-gap="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import YesNoRadioButtons from '../../YesNoRadioButtons.vue';
import USRegionalMapByState from './Regions/USRegionalMapByStateTablet.vue';

export default {
  name: 'LanesTablet',
  components: {
    'yes-no': YesNoRadioButtons,
    'us-regional-map': USRegionalMapByState,
  },
  props: {
    data: Object,
    updateField: Function,
    title: String,
    firstTime: Boolean,
    handleError: Function,
    handleClickCanada: Function,
    handleClickMexico: Function,
    canada: [String, Boolean],
    mexico: [String, Boolean],
    regions: Array,
    addRegion: Function,
    removeRegion: Function,
    inspected: Array,
    preferred: Array,
    preferredByRegion: Object,
    addPreferred: Function,
    removePreferred: Function,
    addPreferredAndRegion: Function,
    removePreferredAndRegion: Function,
    screenSize: String,
    stepName: String,
  },
  data() {
    return {
      executed: false,
      dataAvailable: false,
    };
  },
  watch: {
    stepName: function (val) {
      if (val === 'Lanes') {
        this.handleLoad();
      }
    },
    firstTime(nv) {
      if (nv) this.handleLoad();
    },
  },
  updated() {
    const regionArray = [...document.querySelectorAll('.region')];
    const regionsData = this.regions;
    if (this.title === 'Lanes' && !this.firstTime) {
      regionArray.map((el) => {
        if (regionsData.includes(el.dataset.name)) {
          el.classList.add('region-selected');
          if (el.querySelectorAll('.region-label').length) {
            el.querySelector('.checkedPath').classList.remove('hidden');
            el.querySelector('.region-label').classList.replace(
              'region-label',
              'region-label-selected'
            );
            el.querySelectorAll('rect').forEach((el) => {
              el.setAttribute(
                'width',
                parseFloat(el.getAttribute('width')) + 17
              );
            });
          }
        } else {
          el.classList.remove('region-selected');
          if (el.querySelectorAll('.region-label-selected').length) {
            el.querySelector('.checkedPath').classList.add('hidden');
            el.querySelector('.region-label-selected').classList.replace(
              'region-label-selected',
              'region-label'
            );
            el.querySelectorAll('rect').forEach((el) => {
              el.setAttribute(
                'width',
                parseFloat(el.getAttribute('width')) - 17
              );
            });
          }
        }
        el.replaceWith(el.cloneNode(true));
      });
    }
  },
  mounted() {
    if (this.stepName === 'Lanes') this.handleLoad();
  },
  methods: {
    updateNestedField(path, value) {
      this.$store.commit('updateNestedField', { path, value });
    },
    handleStatesError() {
      this.handleError('selected', !this.preferred.length);
    },
    handleLoad() {
      let inspectedArray = this.inspected;
      let preferredArray = this.preferred;
      const regionsData = this.regions || [];
      const regionArray = [...document.querySelectorAll('.region')];
      const usStatesArray = [
        ...document
          .querySelector('#us_regional_map_by_state')
          .querySelectorAll('.state'),
      ];
      let addPreferred = this.addPreferred;
      let removePreferred = this.removePreferred;
      let handleStatesError = this.handleStatesError;
      let removeRegion = this.removeRegion;
      let addRegion = this.addRegion;
      let inspectedHash = inspectedArray.reduce((map, obj) => {
        map[obj.code] = obj;
        return map;
      }, {});
      const usStatesHash = usStatesArray.reduce((map, obj) => {
        map[obj.classList[2]] = obj;
        return map;
      }, {});
      inspectedArray.forEach((el) => {
        usStatesHash[el.code].classList.add('observed');
      });
      preferredArray.forEach((el) => {
        if (inspectedHash[el.code] === undefined) {
          usStatesHash[el.code].classList.add('preferred');
        } else {
          usStatesHash[el.code].classList.add('preferred-observed');
        }
      });
      regionArray.forEach((el) => {
        if (regionsData.includes(el.dataset.name)) {
          el.querySelectorAll('.state').forEach((state) => {
            state.classList.contains('observed')
              ? state.classList.add('preferred-observed')
              : state.classList.add('preferred');
          });
          el.classList.add('region-selected');
          if (el.querySelectorAll('.region-label').length) {
            el.querySelector('.checkedPath').classList.remove('hidden');
            el.querySelector('.region-label').classList.replace(
              'region-label',
              'region-label-selected'
            );
            el.querySelectorAll('rect').forEach((el) => {
              el.setAttribute(
                'width',
                parseFloat(el.getAttribute('width')) + 17
              );
            });
          }
        } else {
          el.classList.remove('region-selected');
          if (el.querySelectorAll('.region-label-selected').length) {
            el.querySelector('.checkedPath').classList.add('hidden');
            el.querySelector('.region-label-selected').classList.replace(
              'region-label-selected',
              'region-label'
            );
            el.querySelectorAll('rect').forEach((el) => {
              el.setAttribute(
                'width',
                parseFloat(el.getAttribute('width')) - 17
              );
            });
          }
        }
      });
      usStatesArray.forEach((el) => {
        el.classList.add('state-border');
      });
      // if (!this.firstTime) return;
      regionArray.forEach((el) => {
        if (regionsData.includes(el.dataset.name)) {
          [...el.querySelectorAll('.state')].forEach((el) => {
            el.classList.contains('observed')
              ? el.classList.add('preferred-observed')
              : el.classList.add('preferred');
          });
          if (el.querySelectorAll('.region-label').length) {
            el.querySelector('.checkedPath').classList.remove('hidden');
            el.querySelector('.region-label').classList.replace(
              'region-label',
              'region-label-selected'
            );
            el.querySelectorAll('rect').forEach((el) => {
              el.setAttribute(
                'width',
                parseFloat(el.getAttribute('width')) + 17
              );
            });
          }
        } else {
          [...el.querySelectorAll('.state')].forEach((el) => {
            el.classList.remove('preferred-observed', 'preferred');
          });
          if (el.querySelectorAll('.region-label-selected').length) {
            el.querySelector('.checkedPath').classList.add('hidden');
            el.querySelector('.region-label-selected').classList.replace(
              'region-label-selected',
              'region-label'
            );
            el.querySelectorAll('rect').forEach((el) => {
              el.setAttribute(
                'width',
                parseFloat(el.getAttribute('width')) - 17
              );
            });
          }
        }
        if (this.firstTime) {
          el.addEventListener('click', function () {
            if (el.classList.contains('region-selected')) {
              el.classList.remove('region-selected');
              removeRegion(el.dataset.name);
              el.querySelector('.checkedPath').classList.add('hidden');
              el.querySelector('.region-label-selected').classList.replace(
                'region-label-selected',
                'region-label'
              );
              el.querySelectorAll('rect').forEach((el) => {
                el.setAttribute(
                  'width',
                  parseFloat(el.getAttribute('width')) - 17
                );
              });
            } else {
              el.classList.add('region-selected');
              addRegion(el.dataset.name);
              el.querySelector('.checkedPath').classList.remove('hidden');
              el.querySelector('.region-label').classList.replace(
                'region-label',
                'region-label-selected'
              );
              el.querySelectorAll('rect').forEach((el) => {
                el.setAttribute(
                  'width',
                  parseFloat(el.getAttribute('width')) + 17
                );
              });
            }
            let regionalStatesArr = [...el.querySelectorAll('.state')];
            regionalStatesArr.forEach((el) => {
              let stateCode = el.classList[2];
              switch (true) {
                case el.classList.contains('preferred-observed'):
                  el.classList.remove('preferred-observed');
                  el.classList.add('observed');
                  removePreferred(stateCode);
                  break;
                case !el.classList.contains('preferred') &&
                  inspectedHash[stateCode] !== undefined:
                  el.classList.add('preferred-observed');
                  addPreferred(stateCode);
                  break;
                case !el.classList.contains('preferred'):
                  el.classList.add('preferred');
                  addPreferred(stateCode);
                  break;
                default:
                  el.classList.remove('preferred');
                  removePreferred(stateCode);
                  break;
              }
            });
            handleStatesError();
          });
        }
      });
    },
  },
};
</script>

<style>
.region-outline-tablet path {
  fill: #a9adbd;
}

.state-border {
  stroke: #c7cbdb;
  stroke-width: 0.5;
}

.region-hover {
  pointer-events: bounding-box;
}

.region-hover:hover {
  cursor: pointer;
}

.region-hover:hover path:not(.region-label > path) {
  fill: rgba(248, 198, 23, 0.2) !important;
  stroke-width: 0.48;
  stroke: #f8c617 !important;
}

.region-label path {
  fill: gray;
}

.region-selected .region-outline-tablet path {
  fill: rgba(248, 198, 23, 0.2) !important;
  stroke-width: 0.48;
  stroke: #f8c617 !important;
}

.region .region-outline-tablet path {
  stroke-width: 0.48;
  stroke: #a9adbd;
}

.region-label-selected path {
  fill: #e7b812 !important;
}

.region-label-selected rect {
  stroke: #e7b812 !important;
}
.region-label path {
  fill: #a9adbd !important;
}

.region-label rect {
  stroke: #a9adbd !important;
}
</style>
